import { useEffect, useRef, useState } from 'react';
import { sucheAdresse, type AdressTreffer } from '../lib/geokodierung';

/**
 * Adress-Autovervollständigung (Bauphase 3). Entprellt die Eingabe und
 * fragt Amazon Location Service ab; bei Auswahl eines Treffers werden die
 * Adressfelder UND die Geoposition auf einen Schlag gesetzt.
 */
export function AdressSuche({ onAuswahl }: { onAuswahl: (treffer: AdressTreffer) => void }) {
  const [text, setText] = useState('');
  const [treffer, setTreffer] = useState<AdressTreffer[]>([]);
  const [offen, setOffen] = useState(false);
  const [laedt, setLaedt] = useState(false);
  const [fehler, setFehler] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (timer.current) clearTimeout(timer.current);
    if (text.trim().length < 3) {
      setTreffer([]);
      return;
    }
    setLaedt(true);
    timer.current = setTimeout(() => {
      sucheAdresse(text)
        .then((r) => {
          setTreffer(r);
          setOffen(true);
          setFehler(null);
        })
        .catch((e) => setFehler(e instanceof Error ? e.message : String(e)))
        .finally(() => setLaedt(false));
    }, 350);
    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, [text]);

  return (
    <div style={{ position: 'relative' }}>
      <label htmlFor="adress-suche">Adresse suchen</label>
      <input
        id="adress-suche"
        type="text"
        value={text}
        placeholder="z. B. Marktplatz 3, 41564 Kaarst"
        onChange={(e) => setText(e.target.value)}
        onFocus={() => treffer.length > 0 && setOffen(true)}
        onBlur={() => setTimeout(() => setOffen(false), 150)}
        autoComplete="off"
      />
      {laedt ? <div className="label" style={{ marginTop: '0.25rem' }}>sucht …</div> : null}
      {fehler ? <div className="feldfehler">{fehler}</div> : null}
      {offen && treffer.length > 0 ? (
        <ul
          style={{
            listStyle: 'none',
            margin: 0,
            padding: 0,
            position: 'absolute',
            zIndex: 5,
            left: 0,
            right: 0,
            background: 'var(--sahne)',
            border: '1px solid var(--raspel)',
            borderRadius: 'var(--radius)',
            boxShadow: 'var(--schatten)',
            maxHeight: '14rem',
            overflowY: 'auto',
          }}
        >
          {treffer.map((t, i) => (
            <li key={i}>
              <button
                type="button"
                onClick={() => {
                  onAuswahl(t);
                  setText(t.label);
                  setOffen(false);
                }}
                style={{
                  display: 'block',
                  width: '100%',
                  textAlign: 'left',
                  padding: '0.5rem 0.7rem',
                  background: 'none',
                  border: 'none',
                  borderBottom: '1px solid var(--raspel)',
                  cursor: 'pointer',
                  font: 'inherit',
                }}
              >
                {t.label}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
